import { CAROUSEL_TYPES } from './global'

const {
  RECOMMENDED,
  DATA,
  UK_DATA_PASS,
  EU_DATA_PASS,
  OUT_OF_PLAN,
  OUT_OF_PLAN_SECONDARY,
} = CAROUSEL_TYPES

export const TOTAL_PLAN_DATA_THRESHOLD = 12
export const LIMIT_EU_DATA_PASS_3_DAYS = 3
export const LIMIT_EU_DATA_PASS_7_DAYS = 7
export const LIMIT_EU_DATA_PASS_30_DAYS = 30

export const CAROUSEL_IDS = {
  RECOMMENDED: 'recommended',
  DATA: 'data-add-on',
  UK_UNLIMITED_PASS: 'uk-unlimited-pass',
  EU_DATA_PASS: 'eu-data-pass',
  INTERNATIONAL_CALLS: 'international-calls',
  UK_DATA_CALLS: 'uk-data-calls',
}

// Mappings used to set the proper module name for add-ons tracking
export const CAROUSEL_MAPPINGS = {
  [RECOMMENDED]: CAROUSEL_IDS.RECOMMENDED,
  [DATA]: CAROUSEL_IDS.DATA,
  [UK_DATA_PASS]: CAROUSEL_IDS.UK_UNLIMITED_PASS,
  [EU_DATA_PASS]: CAROUSEL_IDS.EU_DATA_PASS,
  [OUT_OF_PLAN]: CAROUSEL_IDS.UK_DATA_CALLS,
  [OUT_OF_PLAN_SECONDARY]: CAROUSEL_IDS.INTERNATIONAL_CALLS,
}

export const EU_DATA_PASS_3_DAYS_ID = '3_DAY_EU_DATA'
export const EU_DATA_PASS_7_DAYS_ID = '7_DAY_EU_DATA'
export const EU_DATA_PASS_30_DAYS_ID = '30_DAY_EU_DATA'

export const EU_DATA_PASS_ADDONS_IDS = [
  LIMIT_EU_DATA_PASS_3_DAYS,
  LIMIT_EU_DATA_PASS_7_DAYS,
  LIMIT_EU_DATA_PASS_30_DAYS,
]
export const EU_DATA_PASS_DAYS_ADDONS_MAPPING = new Map([
  [LIMIT_EU_DATA_PASS_3_DAYS, EU_DATA_PASS_3_DAYS_ID],
  [LIMIT_EU_DATA_PASS_7_DAYS, EU_DATA_PASS_7_DAYS_ID],
  [LIMIT_EU_DATA_PASS_30_DAYS, EU_DATA_PASS_30_DAYS_ID],
])
